import {
  IControlIdDeviceCreateProps,
  IControlIdDeviceProps,
  IControlIdDeviceSimpleProps,
  IControlIdDeviceUpdateParams,
} from './types';
import { api } from '../../../../DefaultService';
import { IPaginationParams } from '../../../../types';
import { IFacialControllerConfigUpdateParams } from '../types';

const ENDPOINT = 'v1/devices/controlId';

export const createControlIdDeviceAsync = async (
  data: IControlIdDeviceCreateProps,
): Promise<IControlIdDeviceProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getControlIdDeviceByIdAsync = async (
  id: number,
): Promise<IControlIdDeviceProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllControlIdDeviceByLicenseAsync = async (
  params?: IPaginationParams,
): Promise<IControlIdDeviceSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, { params })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllControlIdDeviceCountByLicenseAsync =
  async (): Promise<number> => {
    return await api
      .get(`${ENDPOINT}/getAllByLicense/count`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const updateControlIdDeviceAsync = async ({
  id,
  data,
}: IControlIdDeviceUpdateParams): Promise<IControlIdDeviceProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
export const updateConfigControlIdDeviceAsync = async ({
  id,
  data,
}: IFacialControllerConfigUpdateParams): Promise<void> => {
  await api.put(`${ENDPOINT}/${id}/config`, data).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const deleteControlIdDeviceAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
